import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { ContactUs } from 'src/app/shared/services/contact-us/contact-us';
import { ContactUsService } from 'src/app/shared/services/contact-us/contact-us.service';
import { ErrorComponent, InformationComponent } from 'src/app/shared/util/helpers';
import { TrackerService } from 'src/app/shared/util/tracker.service';

export interface CalculatorCard {
  route: string;
  icon: string;
  titleKey: string;
  textKey: string;
}

@Component({
  selector: 'app-calculators',
  templateUrl: './calculators.component.html',
  styleUrls: ['./calculators.component.scss'],
})
export class CalculatorsComponent implements OnInit {
  contactItem: ContactUs = new ContactUs();
  isLoading = false;
  contactSuccess = false;

  readonly calculatorCards: CalculatorCard[] = [
    {
      route: '/calculator1',
      icon: 'lni-apartment',
      titleKey: 'CALCULATORS.FEATURE1_TITLE',
      textKey: 'CALCULATORS.FEATURE1_TEXT',
    },
    {
      route: '/calculator2',
      icon: 'lni-calculator',
      titleKey: 'CALCULATORS.FEATURE2_TITLE',
      textKey: 'CALCULATORS.FEATURE2_TEXT',
    },
    {
      route: '/calculator3',
      icon: 'lni-cog',
      titleKey: 'CALCULATORS.FEATURE3_TITLE',
      textKey: 'CALCULATORS.FEATURE3_TEXT',
    },
    {
      route: '/calculator4',
      icon: 'lni-revenue',
      titleKey: 'CALCULATORS.FEATURE4_TITLE',
      textKey: 'CALCULATORS.FEATURE4_TEXT',
    },
  ];

  constructor(
    public snackBar: MatSnackBar,
    public translate: TranslateService,
    private trackerService: TrackerService,
    private contactUsService: ContactUsService
  ) {}

  ngOnInit(): void {
    this.trackerService.trackPageViews();
    this.contactItem.subject = '';
    this.contactItem.content = '';
    this.contactItem.email = '';
  }

  send(): void {
    if (!this.contactItem.subject || !this.contactItem.email || !this.contactItem.content) {
      this.snackBar.openFromComponent(ErrorComponent, {
        data: { message: 'Vă rugăm să completați toate câmpurile.' },
        duration: 2000,
      });
      return;
    }

    this.isLoading = true;
    this.contactSuccess = false;
    this.contactItem.date = new Date();

    this.contactUsService
      .addItem(this.contactItem)
      .pipe(finalize(() => {
        this.isLoading = false;
      }))
      .subscribe(
        () => {
          this.contactItem.subject = '';
          this.contactItem.email = '';
          this.contactItem.content = '';
          this.contactSuccess = true;
          this.snackBar.openFromComponent(InformationComponent, {
            data: { message: 'Mesajul a fost trimis cu succes!' },
            duration: 2000,
          });
        },
        () => {
          this.snackBar.openFromComponent(ErrorComponent, {
            data: { message: 'A apărut o eroare. Vă rugăm să încercați din nou.' },
            duration: 2000,
          });
        }
      );
  }
}
